export const SA_LAT = -25.7883839;
export const SA_LONG = 28.2786775;
export const SA_ADDRESS1 = 'Menlyn Corporate Park, Block A';
export const SA_ADDRESS2 = '175 Corobay Avenue';
export const SA_ADDRESS3 = 'Waterkloof Glen Ext 11';
export const SA_ADDRESS4 = '0081';
export const SA_TEL = '0860 50 50 50';
export const SA_CLIENT_CARE_EMAIL = 'clientcare@kingprice.co.za';
export const SA_CLAIMS_EMAIL = 'claims@kingprice.co.za';
export const SA_SALES_EMAIL = 'sales@kingprice.co.za';
export const SA_RETENTIONS_EMAIL = 'retentions@kingprice.co.za';
export const SA_KP_FSP_LINE1 = "King Price Insurance Company Ltd is an authorised financial services provider.";
export const SA_KP_FSP_LINE2 = "Licensed insurer | FSP no. 43862";
export const SA_KP_FSP = "" + SA_KP_FSP_LINE1 + " " + SA_KP_FSP_LINE2 + "";
export const SA_COUNTRY_ID = '244';
export const SA_COUNTRY_ID_NUMBER = 244;

export const NAM_LAT = -22.5719118;
export const NAM_LONG = 17.1048878;
export const NAM_ADDRESS1 = '3rd Floor, City Plaza';
export const NAM_ADDRESS2 = 'Sam Nujoma Drive';
export const NAM_ADDRESS3 = 'Windhoek, Namibia';
export const NAM_ADDRESS4 = '9000';
export const NAM_TEL = '083 600 7000';
export const NAM_CLIENT_CARE_EMAIL = 'clientcare@kingprice.co.na';
export const NAM_CLAIMS_EMAIL = 'claims@kingprice.co.na';
export const NAM_SALES_EMAIL = 'sales@kingprice.co.na';
export const NAM_RETENTIONS_EMAIL = 'retentions@kingprice.co.na';
export const NAM_KP_FSP = "King Price Insurance Company of Namibia Ltd. Licence no. 16/ST/31."
export const NAM_COUNTRY_ID = '157';
export const NAM_COUNTRY_ID_NUMBER = 157;

let copyRightGetFullYear = new Date().getFullYear();
export const KP_COPYRIGHT = copyRightGetFullYear + " King Price Insurance Company Ltd"